"use client";

import { ArrowRight, HardHat, Building2, Hammer, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Services() {
  const intro = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const primaryCard = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const secondaryTop = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const secondaryBottom = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const constructionSpecs = [{
    label: "EXPERTISE",
    value: "CONCRETE FORMWORK"
  }, {
    label: "LOCATION",
    value: "VANCOUVER, BC"
  }, {
    label: "QUALITY",
    value: "CERTIFIED"
  }];
  const secondaryCards = [{
    number: "— 02",
    title: "PARKING STRUCTURAL",
    description: "We have a extensive experience building parking structures for commercial and residential projects.",
    icon: Building2,
    link: "Ver servicios comerciales"
  }, {
    number: "— 03",
    title: "Residential Foundation",
    description: "We make strong and durable foundations for all types of construction. In Cowboys we take special care of this aspect of your project.\xA0",
    icon: Users,
    link: "Ver equipo profesional"
  }];
  return <section data-section-id="4680" id="nuestras-especialidades" className="bg-background text-foreground relative overflow-hidden pt-32 pb-24 md:pt-40 md:pb-32 lg:pt-[200px] lg:pb-[160px]">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        {}
        <div ref={intro.ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 transition-all duration-1000 ease-out ${intro.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-7 xl:col-span-8">
            <p className="font-mono tracking-[0.25em] uppercase mb-8 text-accent-foreground !text-xl" style={{
            color: "var(--primary)"
          }}>&nbsp;<span className="!text-3xl">— OUR SERVICES</span> <span className="!text-xs"><span className="!text-3xl text-accent-foreground"><br /><br />WE&nbsp; ARE EQUIPPED TO CARRY OUT ALL KINDS OF PROJECTS RELATED TO THE CONCRETE FORMING, IN ADDITION TO OFFERING ALL THE SERVICES OF QUALIFIED WORKFORCE</span></span><span className="!text-3xl text-accent-foreground"></span></p>
            
          </div>

          <div className="lg:col-span-5 xl:col-span-4 flex lg:items-end">
            
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 mt-24 md:mt-32 lg:mt-[140px]">
          {}
          <div ref={primaryCard.ref} data-index={0} className={`lg:col-span-7 transition-all duration-1000 ease-out ${primaryCard.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <article className="group relative h-full min-h-[520px] lg:min-h-[600px] border backdrop-blur-xl p-8 md:p-10 lg:p-12 flex flex-col transition-all duration-500" style={{
            backgroundColor: "color-mix(in srgb, var(--foreground) 4%, transparent)",
            borderColor: "color-mix(in srgb, var(--foreground) 8%, transparent)"
          }}>
              {}
              <div className="flex items-start justify-between mb-auto">
                <span className="font-mono text-xs tracking-[0.25em] uppercase" style={{
                color: "var(--primary)"
              }}>
                  — 01
                </span>
                <img src="https://genuine-manatee.10web.cloud/wp-content/uploads/2026/06/0249e997-3253-467d-af76-ea60c577b109.jpg" className="!w-[378px] !h-[378px]" />
              </div>

              {}
              <div className="mt-12 md:mt-16">
                <h3 className="font-default font-bold leading-[0.95] tracking-tight text-foreground text-4xl md:text-5xl lg:text-6xl mb-6 md:mb-8">CONCRETE FORMWORK</h3>
                <p className="font-serif text-base md:text-[17px] leading-relaxed max-w-xl" style={{
                color: "color-mix(in srgb, var(--foreground) 75%, transparent)"
              }}>We build dreams and make them come true, any kind of concrete forming, stripping, etc. </p>
              </div>

              {}
              <div className="mt-10 md:mt-12 pt-8 border-t" style={{
              borderColor: "color-mix(in srgb, var(--foreground) 10%, transparent)"
            }}>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                  {constructionSpecs.map((spec, i) => <div key={i} data-index={i}>
                      <p className="font-mono text-[10px] tracking-[0.2em] uppercase mb-2" style={{
                    color: "color-mix(in srgb, var(--foreground) 50%, transparent)"
                  }}>
                        {spec.label}
                      </p>
                      <p className="font-mono text-xs tracking-wider text-foreground">
                        {spec.value}
                      </p>
                    </div>)}
                </div>

                <Link to="/ServicesPage" className="inline-block">
                  
                </Link>
              </div>
            </article>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col gap-6 lg:gap-8">
            {secondaryCards.map((card, i) => {
            const Icon = card.icon;
            const reveal = i === 0 ? secondaryTop : secondaryBottom;
            const offsetClass = i === 1 ? "lg:mt-10" : "";
            return <div key={i} data-index={i} ref={reveal.ref} className={`${offsetClass} transition-all duration-1000 ease-out ${reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
              transitionDelay: `${i * 150}ms`
            }}>
                  <article className="group relative h-full min-h-[280px] border backdrop-blur-xl p-8 md:p-10 flex flex-col transition-all duration-500" style={{
                backgroundColor: "color-mix(in srgb, var(--foreground) 4%, transparent)",
                borderColor: "color-mix(in srgb, var(--foreground) 8%, transparent)"
              }}>
                    <div className="flex items-start justify-between mb-6">
                      <span className="font-mono text-xs tracking-[0.25em] uppercase" style={{
                    color: "var(--primary)"
                  }}>
                        {card.number}
                      </span>
                      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/fa9c5fd4-926f-4c38-9484-410bac1b2551.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/fa9c5fd4-926f-4c38-9484-410bac1b2551.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/fa9c5fd4-926f-4c38-9484-410bac1b2551.jpg-wvc-sizes" className="!w-[230px] !h-[230px]" alt={card.title} loading="lazy" />
                    </div>

                    <div className="mt-auto">
                      <h3 className="font-default font-bold leading-tight tracking-tight text-foreground text-2xl md:text-3xl mb-4">
                        {card.title}
                      </h3>
                      <p className="font-serif text-sm md:text-base leading-relaxed mb-6" style={{
                    color: "color-mix(in srgb, var(--foreground) 75%, transparent)"
                  }}>
                        {card.description}
                      </p>

                      <Link to="/ServicesPage" className="inline-block">
                        
                      </Link>
                    </div>
                  </article>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}